var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Wizard',{ref:"wizard",staticClass:"h-100",attrs:{"steps":_vm.steps,"showNav":true,"showButtons":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }